import { render, staticRenderFns } from "./UseOtherBrowser.vue?vue&type=template&id=ce098880&scoped=true&"
import script from "./UseOtherBrowser.vue?vue&type=script&lang=js&"
export * from "./UseOtherBrowser.vue?vue&type=script&lang=js&"
import style0 from "./UseOtherBrowser.vue?vue&type=style&index=0&id=ce098880&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce098880",
  null
  
)

export default component.exports